import React from 'react';
import {Link, useLocation} from 'react-router-dom'
import Arrow from '../../Images/Arrow.png'
import '../styles/ColumnOrder.css'

function ArrowButton (props){
    const location = useLocation();
    
    // Prevent navigation to the same route
    const handleClick = (e) => {
        const currentPath = location.pathname;
        const targetPath = props.link;
        
        // Only prevent if we're navigating to the exact same route
        if (currentPath === targetPath) {
            e.preventDefault();
            console.log('Preventing navigation to same route:', targetPath);
            return false;
        }
    };

    return (
        <Link to={props.link || '#'} onClick={handleClick}>
            <div className="arrowPos">
                <button className="Noborde">
                    <img src={Arrow} alt='img'></img>
                </button> 
            </div>
        </Link>
        
    );
}
export default ArrowButton